function extractGoogleDriveId(url: string) {
  if (!url || typeof url !== 'string') return null
  const match = url.match(/\/d\/([^\/]+)/)
  return match ? match[1] : null
}

export function convertGoogleDriveUrlToPreview(fileUrl: string) {
  if (!fileUrl || typeof fileUrl !== 'string') return null
  if (fileUrl.includes('drive.google.com')) {
    return `https://drive.google.com/file/d/${extractGoogleDriveId(fileUrl)}/preview`
  } else {
    return fileUrl
  }
}

export function convertGoogleDriveUrlToThumbnail(fileUrl: string) {
  if (!fileUrl || typeof fileUrl !== 'string') return null
  if (fileUrl.includes('drive.google.com')) {
    return `https://drive.google.com/thumbnail?id=${extractGoogleDriveId(fileUrl)}`
  } else {
    return fileUrl
  }
}
